module.exports = __webpack_public_path__ + "media/images/allcare-academy-register-98e0edb73cc1c3b1ffd530db48ea8cd3.png";